const isHttpUrl = (text) => {
    try {
        const { protocol } = new URL(text);
        return protocol === "http:" || protocol === "https:";
    }
    catch (_a) {
        return false;
    }
};
const fileNameFromUrl = (url, idx) => {
    var _a, _b;
    return ((_b = (_a = url
        .split("/")
        .pop()) === null || _a === void 0 ? void 0 : _a.split("?")[0]) === null || _b === void 0 ? void 0 : _b.replace(/^[0-9a-f-]{36}_/i, "")) || `Tekening ${idx + 1}`;
};
// Synced objects: drawingLink = comma-separated URLs, drawingLinkNames = "name1,name2|extraLink".
// Manually created objects: drawingLink is empty and drawingLinkNames holds the typed link.
export const parseDrawingLinks = (drawingLink, drawingLinkNames) => {
    const urls = (drawingLink || "")
        .split(",")
        .map((u) => u.trim())
        .filter(Boolean);
    const [namesPart, extraPart] = (drawingLinkNames || "").split("|");
    const items = [];
    if (urls.length > 0) {
        const names = (namesPart || "").split(",").map((n) => n.trim());
        urls.forEach((url, idx) => {
            items.push({
                label: names[idx] || fileNameFromUrl(url, idx),
                url: isHttpUrl(url) ? url : undefined,
            });
        });
    }
    else if (namesPart === null || namesPart === void 0 ? void 0 : namesPart.trim()) {
        items.push({
            label: namesPart.trim(),
            url: isHttpUrl(namesPart.trim()) ? namesPart.trim() : undefined,
        });
    }
    const extra = extraPart === null || extraPart === void 0 ? void 0 : extraPart.trim();
    if (extra) {
        items.push({ label: extra, url: isHttpUrl(extra) ? extra : undefined });
    }
    return items;
};
